import { Data, Model } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { AppService, Types } from '../DomainTypes';
import RicosCriteria from '../../Reporting/Exports/Ricos/RicosCriteria';
import PRNCriteria from '../../Reporting/Exports/PRNExport/PRNCriteria';
import IFRSExposureCriteria from '../../Reporting/Exports/IFRSExposure/IFRSExposureCriteria';
import SingularInfoCriteria from '../../Reporting/Exports/SingularInfo/SingularInfoCriteria';
import SuperSetCriteria from '../Models/SuperSet/SuperSetCriteria';

export interface IExportApiClient {

    getRicosFile(criteria: Model.PartialPlainObject<RicosCriteria>): AxiosPromise<Blob>;

    getPRNFile(criteria: Model.PartialPlainObject<PRNCriteria>): AxiosPromise<Blob>;

    getIFRSExposureFile(criteria: Model.PartialPlainObject<IFRSExposureCriteria>): AxiosPromise<Blob>;

    getIFRSExposureZipFile(criteria: Model.PartialPlainObject<IFRSExposureCriteria>): AxiosPromise<Blob>;

    getSingularInfoFile(criteria: Model.PartialPlainObject<SingularInfoCriteria>): AxiosPromise<Blob>;

    getSingularInfoZipFile(criteria: Model.PartialPlainObject<SingularInfoCriteria>): AxiosPromise<Blob>;

    getSuperSetZipFile(criteria: Model.PartialPlainObject<SuperSetCriteria>): AxiosPromise<Blob>;

    getPowerPuffZipFile(criteria: Model.PartialPlainObject<SuperSetCriteria>): AxiosPromise<Blob>;

    // Client only properties / methods
}

@injectable()
export default class ExportApiClient extends Data.ApiClientBase implements IExportApiClient {

    constructor (config = AppService.get(Types.App.Config)) {
        super(`${config.apiPath}/exports`);
    }

    public getRicosFile(criteria: Model.PartialPlainObject<RicosCriteria>): AxiosPromise<Blob> {
        return this.axios.post(`${this.apiPath}/ricos`, criteria, { responseType: "blob" });
    }

    public getPRNFile(criteria: Model.PartialPlainObject<PRNCriteria>): AxiosPromise<Blob> {
        return this.axios.post(`${this.apiPath}/prn`, criteria, { responseType: "blob" });
    }

    public getIFRSExposureFile(criteria: Model.PartialPlainObject<IFRSExposureCriteria>): AxiosPromise<Blob> {
        return this.axios.post(`${this.apiPath}/ifrs-exposure`, criteria, { responseType: "blob" });
    }

    public getIFRSExposureZipFile(criteria: Model.PartialPlainObject<IFRSExposureCriteria>): AxiosPromise<Blob> {
        return this.axios.post(`${this.apiPath}/ifrs-exposure-zip`, criteria, { responseType: "blob" });
    }

    public getSingularInfoFile(criteria: Model.PartialPlainObject<SingularInfoCriteria>): AxiosPromise<Blob> {
        return this.axios.post(`${this.apiPath}/singular-info`, criteria, { responseType: "blob" });
    }

    public getSingularInfoZipFile(criteria: Model.PartialPlainObject<SingularInfoCriteria>): AxiosPromise<Blob> {
        return this.axios.post(`${this.apiPath}/singular-info-zip`, criteria, { responseType: "blob" });
    }

    public getSuperSetZipFile(criteria: Model.PartialPlainObject<SuperSetCriteria>): AxiosPromise<Blob> {
        return this.axios.post(`${this.apiPath}/superset-zip`, criteria, { responseType: "blob" });
    }

    public getPowerPuffZipFile(criteria: Model.PartialPlainObject<SuperSetCriteria>): AxiosPromise<Blob> {
        return this.axios.post(`${this.apiPath}/powerpuff-zip`, criteria, { responseType: "blob" });
    }

    // Client only properties / methods
}